import { getStringReplacerUtil } from '../../main/utils/string-replacer.util.ts';

import { EnvironmentLinkEnum } from '../constants/environment-url.ts';

interface Props {
  isProduction: boolean;
  environmentName?: string;
}

export const mapEnvironmentUrl = ({ isProduction, environmentName }: Props): string => {
  if (isProduction) {
    return EnvironmentLinkEnum.PRODUCTION;
  }

  return getStringReplacerUtil().replace(EnvironmentLinkEnum.INTEGRATION, {
    ENVIRONMENT: environmentName ?? '',
  });
};
